



































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { YKDCenterDrawer } from 'gum-ui'
import { queryAllRoles } from '@/api/role/role'
import { Role } from '../../model/role/role'
@Component({
  components: { YKDCenterDrawer }
})
export default class RolesSelector extends Vue {
  @Prop() centerDrawer?: boolean

  private roles: Role[] = []

  private loading: boolean = false

  private selectedRoleKeys: string[] = []

  private columns = [
    {
      title: '角色标题',
      dataIndex: 'title',
      key: 'title'
    },
    {
      title: '角色名称',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: '类型',
      dataIndex: 'roleType',
      key: 'roleType'
    }
  ]

  closeCenter() {
    this.selectedRoleKeys = []
    this.$emit('closeCenter')
  }

  confirm() {
    let roleDatas: Role[] = []
    if(this.roles && this.roles.length>0 && this.selectedRoleKeys.length>0){
      this.roles.forEach(role=>{
        if(this.selectedRoleKeys.indexOf(role.id!) > -1){
          roleDatas.push(role)
        }
      })
    }

    this.$emit('confirm', roleDatas)
    this.closeCenter()
  }

  async mounted() {
    this.loading = true
    this.roles = await queryAllRoles()
    this.loading = false
  }

  onSelectChange(selectedRoleKeys: string[]) {
    this.selectedRoleKeys = selectedRoleKeys
  }

  onAccountChange() {}

  onSelectAllAccount() {}
}
